(function () {
  // Check if we're on a product page or cart page
  const isProductPage = window.location.pathname.includes('/products/');
  const isCartPage = window.location.pathname.includes('/cart');
  const shouldExecute = isProductPage || isCartPage;

  function handleProductCards() {
    // Find all product cards in the document
    const defaultCards = document.querySelectorAll('.product-item-default');
    const recommendedCards = document.querySelectorAll('.product-item-recommended');

    // Function to hide author info if it contains array values
    function hideArrayAuthorInfo(cards) {
      cards.forEach(card => {
        const authorElements = card.querySelectorAll('.product-card-info-line--value');

        authorElements.forEach(element => {
          const text = element.textContent.trim();

          if (text.includes('[') && text.includes(']')) {
            element.closest('.product-card-info-line').style.display = 'none';
          }
        });
      });
    }

    if (shouldExecute) {
      // On PDP or Cart: Hide all default cards, show all recommended cards
      defaultCards.forEach(card => {
        card.style.display = 'none';
      });

      recommendedCards.forEach(card => {
        card.style.display = 'block';
        card.className = 'card-inner';
      });

      // Hide array author info in recommended cards
      hideArrayAuthorInfo(recommendedCards);
    } else {
      // On collection/search: Show all default cards, hide all recommended cards
      defaultCards.forEach(card => {
        card.style.display = 'block';
      });

      recommendedCards.forEach(card => {
        card.style.display = 'none';
      });

      // Hide array author info in default cards
      hideArrayAuthorInfo(defaultCards);
    }
  }

  // Initial check for existing elements
  handleProductCards();

  // Set up MutationObserver to watch for dynamically added product cards
  const observer = new MutationObserver(function (mutations) {
    let shouldHandle = false;

    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node or its children contain product cards
            if (
              node.classList &&
              (node.classList.contains('product-item-default') || node.classList.contains('product-item-recommended'))
            ) {
              shouldHandle = true;
            } else if (
              node.querySelector &&
              (node.querySelector('.product-item-default') || node.querySelector('.product-item-recommended'))
            ) {
              shouldHandle = true;
            }
          }
        });
      }
    });

    if (shouldHandle) {
      handleProductCards();
    }
  });

  // Start observing the document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
